import { Category } from '@modules/common/types';

export const getCategoryTypeFromString = (
  categoryStr: string,
): Category | null => {
  switch (categoryStr?.toLowerCase()) {
    case 'complaint':
      return Category.Complaint;
    // TODO: Remove this once BE has complaint enum
    // Used this in `getQueryStringOptionFromFilter` and `FieldIcon`
    // to get the category from issue as a string
    case 'issue':
      return Category.Complaint;
    case 'improvement':
      return Category.Improvement;
    case 'help':
      return Category.Help;
    case 'praise':
      return Category.Praise;
    default:
      return null;
  }
};
